import React, {ReactNode, useCallback} from 'react'
import {FormSection} from "../common/components/SectionedForm";
import {useTranslation} from "react-i18next";
import PaperStack from "../common/form/PaperStack";
import FormGroup from "../common/form/FormGroup";
import {LabelValues, LabelValueType} from "../common/components/LabelValues";
import {TrunkingSite} from "../app/types";
import HubIcon from "@mui/icons-material/Hub";
import {formatPhoneNumber} from "../common/util/formatters";
import {renderNumberRanges} from "./index";
import {Alias} from "../group/Alias"


export const useGeneralSection = (isFetching: boolean, error: any, refetch: () => void, data?: TrunkingSite) : FormSection<TrunkingSite> => {
    const { t } = useTranslation()

    const infoLabelValues = useCallback((value: TrunkingSite): LabelValueType[] => [
        {
            label: t(`trunking-sites.table.name`),
            value: <>{value.name}</>,
        },
        {
            label: t(`Alias`),
            value: <Alias productId={value.productId}/> ,
        },
        {
            label: t(`trunking-sites.table.product-id`),
            value: <>{value.productId}</>,
        },
        {
            label: t(`trunking-sites.table.type`),
            value: <>{t(`trunking-sites.product-types.${value.type}`)}</>,
        },
        {
            label: t(`trunking-sites.table.nr-of-channels`),
            value: <>{value.nrOfCalls}</>,
        },
        {
            label: t(`site.cards.general.main-number`),
            value: <>{formatPhoneNumber(value.mainNumber)}</>,
        },
        {
            label: t(`trunking-sites.table.number-ranges`),
            value: renderNumberRanges(value.numberRanges),
        },
    ], [t])

    const renderDetails = useCallback(
        (trunkingSite: TrunkingSite): ReactNode => {
            return (
                <PaperStack>
                    <FormGroup fullWidth={true} key={2}>
                        <LabelValues labelValues={infoLabelValues(trunkingSite)} />
                    </FormGroup>
                    <></>
                </PaperStack>
            )
        },
        [infoLabelValues],
    )

    return {
        title: t('general.general'),
        data: data,
        isFetching: isFetching,
        error: error,
        refetch: refetch,
        renderDetails: renderDetails,
        renderForm: null,
        enabled: () => true,
        icon: () => <HubIcon/>
    }
}